import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useCallback, useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { LOCATIONS_SEPARATOR } from '../../../../../configs'
import { TRANSLATION_KEYS } from '../../../../../translations'
import { TRANSLATION_KEYS as APPLICABLE_TRANSLATION_KEYS } from '../../../../applicableToggle/translations'
import { LocationsListDialog } from '../../../../locationsListDialog/LocationsListDialog'

import styles from './WarehousesReadMode.module.scss'

interface IWarehousesReadModeProps {
  count: Nullable<number>
  locations: string
  isApplicable: boolean
}

export const WarehousesReadMode: FC<IWarehousesReadModeProps> = ({
  count,
  locations: locationsString,
  isApplicable,
}) => {
  const [showLocationsList, setShowLocationsList] = useState(false)

  const locations = useMemo(() => {
    return locationsString.split(LOCATIONS_SEPARATOR).filter((it) => it)
  }, [locationsString])

  const closeLocationsList = useCallback(() => {
    setShowLocationsList(false)
  }, [])

  const openLocationsList = useCallback(() => {
    setShowLocationsList(true)
  }, [])

  if (!isApplicable) {
    return (
      <div className={styles.root}>
        <b>
          <Translation text={APPLICABLE_TRANSLATION_KEYS.notApplicable} />
        </b>
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <div className={styles.countWrapper}>
        <div className={styles.countValue}>{count}</div>
        <div className={styles.countLabel}>
          <Translation text={TRANSLATION_KEYS.locationsAndCount.countLabel} />
        </div>
      </div>
      <div className={styles.locationWrapper}>
        <div className={styles.iconContainer}>
          <i className="kbase kbase-omni-location-pin" />
        </div>
        <div className={styles.locationContent} onClick={openLocationsList}>
          <div className={styles.locationValue}>{locations[0] || '-'}</div>
          <div className={styles.locationLabel}>
            <Translation text={TRANSLATION_KEYS.locationsAndCount.locationsClickToViewLabel} />
          </div>
        </div>
      </div>

      {showLocationsList && (
        <LocationsListDialog onClose={closeLocationsList} locations={locationsString} />
      )}
    </div>
  )
}
